export const splitHref = (hubId, title, amount, date) =>
  `/h/${hubId}/money/splits?${new URLSearchParams({ new: "1", title: title || "", amount: String(amount ?? ""), date: date || "" })}`;

export const writesLocked = (hub) => !!hub.read_only || hub.plan?.status === "lapsed";
